import appConfig from "./appConfig";

const prefix_auth = "/auth"
const prefix_agent = "/agent"
const prefix_referrer = "/referrer"
const prefix_leads = "/leads"
const prefix_tnc = "/tnc"
const prefix_ph = "/payment-history"
const prefix_document = "/document"
const prefix_news = "/news"
const prefix_mfa = "/mfa"

const urlConfig = {
  /* AUTH */
  "LOGIN": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_auth + '/login',
    needToken: false
  },
  "VERSION": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_auth + '/microsite-version',
    needToken: false
  },
  "GENERATE_TOKEN": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_auth + '/generate-token',
    needToken: false
  },
  "LOGOUT": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_auth + '/destroy',
    needToken: true
  },
  /* AGENT */
  "AGENT_ADD": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_agent + '/add',
    needToken: true
  },
  "GENERATE_OTP_AGENT": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_agent + '/generate/otp',
    needToken: true,
    generateToken: true
  },
  "VERIFY_OTP_AGENT": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_agent + '/verify/otp',
    needToken: true
  },
  "AGREE_TNC": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_agent + '/agree-tnc',
    needToken: true,
    generateToken: true
  },
  /* REFERRER */
  "GENERATE_OTP_REF": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/generate/otp',
    needToken: true,
  },
  "REFERRER_EDIT_WAITING": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/edit-waiting',
    needToken: true,
  },
  "REFERRER_EDIT_REGISTERED": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/edit-registered',
    needToken: true,
  },
  "VERIFY_OTP_REF": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/verify/otp',
    needToken: true
  },
  "CHANGE_PWD": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/change-password',
    needToken: true
  },
  "FORGOT_PWD": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/forgot-password',
    needToken: false
  },
  "AGREE_TNC_REF": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/agree-tnc',
    needToken: true
  },
  "REFERRER_UPDATE_OTP_FLAG": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/update-otp-flag',
    needToken: true
  },
  "REFERRER_LIST": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer,
    needToken: true,
    generateToken: true
  },
  "REFERRER_DETAIL": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + "/microsite",
    needToken: true
  },
  "REFERRER_ADD": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/add',
    needToken: true,
    generateToken: true
  },
  "REFERRER_TERMINATED_ADD": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/add-terminated',
    needToken: true,
    generateToken: true
  },
  "REFERRER_TERMINATED": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/detail-terminated',
    needToken: true,
    generateToken: true
  },
  "REFERRER_FILE": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/file',
    needToken: true,
    generateToken: true
  },
  /* LEADS */
  "LEADS_LISTING": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_leads + '/microsite',
    needToken: true
  },
  "LEADS_ADD": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_leads + '/add',
    needToken: true
  },
  "LEADS_DOWNLOAD": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_leads + '/export-by-refcode',
    needToken: true
  },
  "PAYMENT_HISTORY": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_ph,
    needToken: true
  },
  "PAYMENT_HISTORY_PER_LEAD": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_ph + '/per-lead',
    needToken: true
  },
  "PAYMENT_HISTORY_CALCULATE": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_ph + '/calculation',
    needToken: true
  },
  "PAYMENT_HISTORY_CALCULATE_PER_LEAD": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_ph + '/calculation-per-lead',
    needToken: true
  },
  "PAYMENT_HISTORY_DOWNLOAD": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_ph + '/download',
    needToken: true
  },
  "PAYMENT_HISTORY_PER_LEAD_DOWNLOAD": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_ph + '/per-lead/download',
    needToken: true
  },
  /* MASTER */
  "NEEDS": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: '/needs',
    needToken: true
  },
  "TNC_AGENT": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_tnc + '/agent',
    needToken: true,
    generateToken: true
  },
  "TNC_REFERRER": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_tnc + '/referrer',
    needToken: true
  },
  "TNC_DOWNLOAD": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_tnc + '/download',
    needToken: true
  },
  "MASTER_BANK": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: '/mst/bank',
    needToken: true
  },
  "MASTER_COUNTRIES": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: '/mst/countries',
    needToken: true
  },
  /* DOCUMENT */
  "DOCUMENT": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_document,
    needToken: true
  },
  "DOCUMENT_DOWNLOAD": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_document + '/download',
    needToken: true
  },
  "NEWS": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_news,
    needToken: true
  },
  "DRAFT_LIST": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/draft',
    needToken: true,
    generateToken: true
  },
  "DRAFT_DELETE": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/draft',
    needToken: true,
    generateToken: true
  },
  "DRAFT_ADD": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_referrer + '/draft',
    needToken: true,
    generateToken: true
  },
  "VERIFY_CAPTCHA": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: "/captcha/verify",
    needToken: true
  },
  "VERIFY_CAPTCHA_V2": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: "/captcha/v2/verify",
    needToken: true
  },
  "MFA_REQ_OTP": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_mfa + '/reqOtp',
    needToken: false
  },
  "MFA_VERIFY_OTP": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_mfa + '/verifyOtp',
    needToken: false
  },
  "MFA_VERIFY_TOKEN": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_mfa + '/verifyToken',
    needToken: false
  },
  "MFA_DELETE_TOKEN": {
    method: 'post',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_mfa + '/deleteToken',
    needToken: false
  },
  "SYSTEM_PARAMETER": {
    method: 'get',
    baseUrl: appConfig.apiMiddleware,
    endpoint: prefix_mfa + '/system-parameter',
    needToken: false
  },
}

export default urlConfig
